import api from "./api";

export interface Tag {
  id: string;
  slug: string;
  nome: string;
  cor: string;
  icone: string;
  ativo: boolean;
  ordem: number;
}

export async function listarTags(opts?: { todos?: boolean }) {
  const r = await api.get(`/tags${opts?.todos ? "?todos=1" : ""}`);
  return r.data.data as Tag[];
}

export async function criarTag(dados: { nome: string; slug?: string; cor?: string; icone?: string; ordem?: number }) {
  const r = await api.post("/tags", dados);
  return r.data.data as Tag;
}

export async function atualizarTag(id: string, dados: Partial<{ nome: string; cor: string; icone: string; ativo: boolean; ordem: number }>) {
  const r = await api.patch(`/tags/${id}`, dados);
  return r.data.data as Tag;
}

export async function excluirTag(id: string) {
  await api.delete(`/tags/${id}`);
}
